// Shared ADAS report status helpers for the Client Portal report list.
//
// A client-portal upload persists a bare report immediately, then adasThink
// enriches it in the background. Its generation state must therefore be read
// from `adasThink.status` — NOT from `subStatus` (which the Admin Portal owns
// and only clears when an admin views the report) and NOT from the workflow
// stage name (a COMPLETED report legitimately sits in stages like "Added"/
// "Submitted"). Keying on either of those kept completed reports stuck as
// "processing" in the client portal until an admin opened them.

const CLIENT_SOURCES = ['Client', 'Client Portal', 'client-portal', 'client-portal-upload']

const adasStatusOf = (report) =>
  ((report && report.adasThink && report.adasThink.status) || '').toLowerCase().trim()

const isClientUpload = (report) =>
  !!report && CLIENT_SOURCES.indexOf(report.source) !== -1

// Still generating: a client upload whose adasThink enrichment hasn't finished
// (or failed). Non-client reports (admin/CCC) are persisted only once complete,
// and admin-manual reports have no adasThink stage — so they are never treated
// as processing here.
export const isReportProcessing = (report = {}) => {
  const status = (report.status || '').toLowerCase().trim()
  const adasStatus = adasStatusOf(report)
  if (isClientUpload(report) && adasStatus !== 'completed' && adasStatus !== 'failed') return true
  return status === 'processing' || report.isProcessing === true || report.processing === true
}

// adasThink enrichment failed — render a distinct error row instead of an
// indefinite spinner (and the report stays hidden from the admin/mobile list).
export const isReportFailed = (report = {}) =>
  isClientUpload(report) && adasStatusOf(report) === 'failed'
